import { Disposable } from '../../utils/DisposableContainer/DisposableContainer';

export class DisposableCollection<T> {
  private lastId: number = 0;
  private disposableItems: Array<DisposableItem<T>> = [];

  public add(item: T): Disposable {
    const disposableItem: DisposableItem<T> = {
      item,
      id: ++this.lastId
    };

    this.disposableItems.push(disposableItem);

    return {
      dispose: () => {
        this.remove(disposableItem.id);
      }
    };
  }

  public clear(): void {
    this.disposableItems = [];
  }

  public toArray(): Array<T> {
    return this.disposableItems.map((di) => di.item);
  }

  public size(): number {
    return this.disposableItems.length;
  }

  private remove(id: number): void {
    this.disposableItems = this.disposableItems.filter((disposableItem) => {
      return disposableItem.id !== id;
    });
  }
}

type DisposableItem<T> = {
  id: number;
  item: T;
};
